import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";

// Counts how many times each page is opened (see backend/stats.py). Every time the page changes, the server is told which page
// it was and adds one to that page's count for today. No name, email address or list of what one person did is kept.
//
// Two small things are kept in the browser (localStorage):
//   dtm_seen    "1" once this browser has been here, so the first visit of a guest can be counted as new
//   dtm_nocount "1" when Dan switched on "Don't count visits from this browser" in Admin (his own testing while logged out)
const SEEN_KEY = "dtm_seen";
export const NO_COUNT_KEY = "dtm_nocount";

export function countThisBrowser() {
  try { return window.localStorage.getItem(NO_COUNT_KEY) !== "1"; } catch { return true; }
}

export function setCountThisBrowser(on) {
  try {
    if (on) window.localStorage.removeItem(NO_COUNT_KEY);
    else window.localStorage.setItem(NO_COUNT_KEY, "1");
  } catch { /* a browser that will not keep it: nothing to do */ }
}

export default function PageStats() {
  const { pathname } = useLocation();
  const last = useRef({ path: "", at: 0 });

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;                  // Dan's own Admin page is never counted
    if (typeof document !== "undefined" && document.visibilityState === "prerender") return;
    if (!countThisBrowser()) return;
    const now = Date.now();
    if (last.current.path === pathname && now - last.current.at < 2000) return;   // the same page twice in a blink is one visit
    last.current = { path: pathname, at: now };
    let isNew = false;
    try {
      if (window.localStorage.getItem(SEEN_KEY) === null) { window.localStorage.setItem(SEEN_KEY, "1"); isNew = true; }
    } catch { isNew = false; }                                   // a browser that cannot keep the marker is never counted as new
    api.post("/stats/hit", { path: pathname, new: isNew }).catch(() => {});
  }, [pathname]);

  return null;
}
